import React, { PropTypes } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import NewOrganizationApplicationForm from '../components/NewOrganizationApplicationForm'
import NewOrganizationRecommendationForm from '../components/NewOrganizationRecommendationForm'
import {
  UserIsAuthenticated,
  UserIsVerified
} from '../utils/auth'
import {
  doSaveMe
} from '../actions'
import DocumentMeta from 'react-document-meta'
import { asyncActions } from 'react-async-actions'
import { removeFlowStep } from '../utils'


const actionsToFire = (props) => {
  let actions = []
  const { auth } = props
  const { user } = auth
  if (!auth.isLoading && user) {
    const { depot: { flow } } = user
    if (flow && flow.length > 0) {
      actions.push(props.doSaveMe({ depot: { flow: removeFlowStep(flow, '/organizations/new')}}))
    }
  }
  return actions
}

function mapStateToProps (state) {
  return state
}

@UserIsAuthenticated
@UserIsVerified
@connect(mapStateToProps, { doSaveMe })
@asyncActions(actionsToFire)
class AddResource extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: 'apply'
    }
  }

  setActiveTab = (props) => {
    const { browser, location } = props
    switch (location.hash) {
      case '#apply':
      case '#recommend':
        this.setState({tab: location.hash.substr(1)})
        break
       default:
        this.setState({tab: 'apply'})
    }
  }

  componentWillMount() {
    this.setActiveTab(this.props)
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setActiveTab(nextProps)
  }

  componentWillUnmount() {}

  render() {
    const { browser, location } = this.props
    let seoTitle = ''
    let seoDescription = ''


    let headlineMarkup = (
      <h2 className='headline'>
        Help us grow by applying to list your organization
        or recommending your favorite resource.
      </h2>
    )

    const meta = {
      title: seoTitle,
      description: seoDescription,
    }

    const applyForm = <NewOrganizationApplicationForm />
    const recommendForm = <NewOrganizationRecommendationForm />

    console.info('location ===>', location)
    console.info('state ===>', this.state )
    const tabApplyActive = (this.state.tab === 'apply') ? 'active' : ''
    const tabRecommendActive = (this.state.tab === 'recommend') ? 'active' : ''
    const form = (this.state.tab === 'recommend') ? recommendForm : applyForm
    let forms = (
      <div className="tabsContainer">
        <ul className="tabs">
          <li className={tabApplyActive}><Link to="/organizations/new#apply">Apply</Link></li>
          <li className={tabRecommendActive}><Link to="/organizations/new#recommend">Recommend</Link></li>
        </ul>
        <div className="tabContent">
          {form}
        </div>
      </div>
    )

    if (browser.greaterThan.tablet) {
      forms = [applyForm, recommendForm]
    }

    return (
      <div className="pageContainer">
        <DocumentMeta {...meta} />
        <div className="staticCollageHolder">&nbsp;</div>
        <div className="page addResource">
          {headlineMarkup}
          <div className="formContainer">
            { forms }
          </div>
        </div>
      </div>
    )
  }
}

export default AddResource



// WEBPACK FOOTER //
// ./src/containers/AddResource.jsx